import { Route, Routes } from 'react-router-dom';
import { ProtectedRouter } from 'infrastructure/routing';
import { GlobalProtectedRoute } from 'framework/authorization';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { Features, featureToggles } from 'infrastructure/featureToggle';
import { POSITION_SLOTS_PATH, POSITION_SLOT_LIST_READ } from './constants';
import PositionSlotsListPage from './List';
import PositionSlotsCollectionPreviewPage from './preview/List';
import { POSITION_SLOT_LIST_READ as POSITION_SLOT_LIST_READ_NEW, POSITION_SLOT_READ } from './preview/constants';
import PositionSlotShowPage from './preview/show';
import { usePositionSlotsRoute } from 'domain/shared/positionSlot';

const collectionPreviewEnabled = Boolean(featureToggles[Features.POSITION_SLOTS_COLLECTION_PREVIEW]);

const PositionSlotsRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute, singleEntityRoute } = usePositionSlotsRoute();

  return (
    <ProtectedRouter basePath={POSITION_SLOTS_PATH}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={POSITION_SLOT_LIST_READ_NEW}>
              <PositionSlotsCollectionPreviewPage />
            </GlobalProtectedRoute>
          }
        />

        {collectionPreviewEnabled && (
          <Route
            path={singleEntityRoute}
            element={
              <GlobalProtectedRoute globalPermissionToCheck={POSITION_SLOT_READ}>
                <PositionSlotShowPage />
              </GlobalProtectedRoute>
            }
          />
        )}

        {/* TODO: Remove the old slots after some time has passed */}
        <Route
          path="preview"
          element={
            <GlobalProtectedRoute globalPermissionToCheck={POSITION_SLOT_LIST_READ}>
              <PositionSlotsListPage />
            </GlobalProtectedRoute>
          }
        />
        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

PositionSlotsRouter.getRouterPath = () => `${POSITION_SLOTS_PATH}/*`;

export default PositionSlotsRouter;
